import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-paginator',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
})
export class PaginatorComponent implements OnInit {
  public selected: any;
  @Input() pageIndex: number | undefined;
  @Input() pageSize: number | undefined;
  @Input() totalCount: number | undefined;
  @Input() customizedPagiantor: boolean = false;
  @Input() page: number[] = [50, 100, 200, 500];
  @Input() from: number = 0;
  @Input() to: number = 0;

  @Output() pageSizeChange = new EventEmitter<any>();
  @Output() decrementValue = new EventEmitter<any>();
  @Output() incrementValue = new EventEmitter<any>();
  @Output() overIncrementValue = new EventEmitter<any>();
  @Output() overDecrementValue = new EventEmitter<any>();

  ngOnInit() {
    this.selected = this.pageSize;
  }

  public pageChange(event: any) {
    let pageNumber;
    if (
      typeof this.totalCount !== 'undefined' &&
      typeof this.pageIndex !== 'undefined'
    ) {
      pageNumber = Math.floor(this.totalCount / event);
      this.pageIndex =
        this.pageIndex > pageNumber
          ? pageNumber < 1
            ? 1
            : pageNumber
          : this.pageIndex;
    }
    let perPage = { pageIndex: this.pageIndex, pageSize: event };
    this.pageSizeChange.emit(perPage);
  }

  public decrement() {
    if (typeof this.pageIndex !== 'undefined') {
      if (this.pageIndex >= 0) {
        this.pageIndex--;
        this.decrementValue.emit(this.pageIndex);
      }
    }
  }
  public increment() {
    if (typeof this.pageIndex !== 'undefined') {
      this.pageIndex++;
      this.incrementValue.emit(this.pageIndex);
    }
  }
  public overIncrement() {
    let overIncrement;
    if (
      typeof this.totalCount !== 'undefined' &&
      typeof this.pageSize !== 'undefined'
    ) {
      overIncrement = Math.floor(this.totalCount / this.pageSize);
      if (Number.isInteger(this.totalCount / this.pageSize)) {
        this.overIncrementValue.emit(overIncrement);
      } else {
        this.overIncrementValue.emit(overIncrement + 1);
      }
    }
  }

  public OverDecrement() {
    this.overDecrementValue.emit();
  }
}
